import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formActions: [
            // {
            //     btn_text: '<i class="fas fa-trash"></i> Reset',
            //     event_name: "customClick",
            //     class: "btn btn-secondary my-custom-class mx-1",
            //     event_payload: 'resetForm'
            // }
        ],
        headerFields: [
            {
                name: "rowId",
                label: "ID",
                visibility: false
            },
            {
                name: "selectedOtherBillableItems",
                label: "Egyéb számlázható tételek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getOtherBillableItemsForCheckboxes,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                formVisible: true,
            },
        ]
    }
}
